var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNow),expression:"showNow"}],staticClass:"gear__rotate--slow xer-rotate xer-h-15 xer-pointer-events-none",attrs:{"src":_vm.getPictogramUrl('gear'),"alt":"Processing"}})
}
var staticRenderFns = []

export { render, staticRenderFns }